import React from "react";
import { Col, Row } from "reactstrap";

import AudioIcon from "../../assets/images/app/allaya/dashboard/audio-icon.svg";
import FreemiumIcon from "../../assets/images/app/allaya/dashboard/fremium-users.svg";
import PremiumIcon from "../../assets/images/app/allaya/dashboard/premium-users.svg";
import ActiveUsers from "../../assets/images/app/allaya/dashboard/active-users.svg";

import { SummaryCard } from "../../components/SummaryCard";
import StatsCard from "./StatsCard";
import { LoaderFallbackUI } from "../../components/LoaderFallbackUI";

const AnalyticsSection = ({ analytics, isAnalyticsFetching }) => {
    const stats = [
        {
            icon: AudioIcon,
            title: "Total",
            subText: "Audios",
            count: analytics?.totalAudios || 0,
            styles: {
                card: "bg-audio",
                titleClass: "audio-text",
                countClass: "audio-text",
                subTextClass: "audio-text"
            }
        },
        {
            icon: PremiumIcon,
            title: "Total",
            subText: "Premium Users",
            count: analytics?.totalPremiumUsers || 0,
            styles: {
                card: "bg-premium",
                titleClass: "premium-text",
                countClass: "premium-text",
                subTextClass: "premium-text"
            }
        },
        {
            icon: FreemiumIcon,
            title: "Total",
            subText: "Freemium Users",
            count: analytics?.totalFreemiumUsers || 0,
            styles: {
                card: "bg-freemium",
                titleClass: "freemium-text",
                countClass: "freemium-text",
                subTextClass: "freemium-text"
            }
        },
        {
            icon: ActiveUsers,
            title: "Total Active Users",
            subText: " (past 30 days)",
            count: `${analytics?.totalActiveUsers || 0}`,
            styles: {
                card: "bg-revenue",
                titleClass: "revenue-text",
                countClass: "revenue-text",
                subTextClass: "revenue-text"
            }
        }
    ];
    return (
        <SummaryCard
            cardProps={{
                style: { borderRadius: "32px", padding: "16px" },
                className: "p-3"
            }}
        >
            {isAnalyticsFetching ? (
                <LoaderFallbackUI isLoader={isAnalyticsFetching} className={"h-100"} />
            ) : (
                <Row>
                    {stats.map((stat, index) => (
                        <Col sm={12} md={6} lg={6} xl={3} key={index}>
                            <StatsCard {...stat} />
                        </Col>
                    ))}
                </Row>
            )}
        </SummaryCard>
    );
};

export default AnalyticsSection;
